import { RouteObject } from "react-router-dom";
import { PlanAndOptionsPage } from "src/routes/developments/plan-and-options/PlanAndOptionsPage";
import { PlanDetailsPage } from "src/routes/developments/plan-and-options/PlanDetailsPage";
import * as planAndOptionsPaths from "src/routing/domains/developments/plan-and-options/planAndOptionsPaths";

/**
 * SideNav leaf routes for development plan-and-options section.
 *
 * Role: data router domain leaves. Spread under `DevelopmentLegacySideNavLayout` in `detail/developmentDetail.tsx`.
 */
export const planAndOptionsSideNavRoutes: RouteObject[] = [
  { path: planAndOptionsPaths.developmentPlanAndOptionsRoute.path, Component: PlanAndOptionsPage },
  { path: `${planAndOptionsPaths.developmentPlanDetailsRoute.path}/*`, Component: PlanDetailsPage },
];
